import { j as s, c as t } from "../../utils-BdNIfrGQ.js";
import { n as e } from "../../normalize-spacing-DY0KSpr_.js";
import { S as i } from "../../separator-CQVuQllV.js";
import { c as d } from "../../index-Di82Y7n3.js";
const n = d("", {
  variants: {
    variant: {
      solid: "border-solid",
      // 1:1
      dashed: "border-dashed"
      // 1:1
    }
  },
  defaultVariants: {
    variant: "solid"
  }
}), f = ({ spacing: r, variant: a, ...o }) => /* @__PURE__ */ s.jsx(
  i,
  {
    className: t(n({ variant: a }), "border-border", e(r)),
    ...o
  }
);
export {
  f as default
};
